import React from 'react';
import Routes from './Routes';

export default () => <Routes />;



// WEBPACK FOOTER //
// ./src/app/routes/App.js